import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import PrimaryButton from '../components/PrimaryButton';

// CSS global para garantir que não haja espaços em branco
const globalStyles = `
  html, body, #root {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }
`;

const PitchNascer: React.FC = () => {
  const handleDemoClick = () => {
    window.open('https://thinkway.app/tw/demo-login', '_blank');
  };

  // Aplicar estilos globais
  React.useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = globalStyles;
    document.head.appendChild(styleElement);
    
    return () => {
      styleElement.remove();
    };
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        height: '100vh',
        background: 'linear-gradient(135deg, #042E4B 0%, #1A5B7A 100%)',
        py: { xs: 1, md: 2 },
        px: { xs: 1, md: 2 },
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Container 
        maxWidth="lg" 
        sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column',
          height: '100%',
          maxHeight: '100vh',
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
            mb: 2,
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            sx={{
              color: 'white',
              fontWeight: 'bold',
              mb: 0.5,
              fontSize: { xs: '1.3rem', md: '1.8rem' },
              lineHeight: 1.2,
            }}
          >
            Pitch da ThinkWay para o Programa Nascer 2025
          </Typography>
          <Typography
            variant="h6"
            component="h2"
            sx={{
              color: 'rgba(255, 255, 255, 0.8)',
              fontWeight: 300,
              mb: 1,
              fontSize: { xs: '0.9rem', md: '1rem' },
              lineHeight: 1.3,
            }}
          >
            Conheça nossa solução inovadora para planejamento estratégico
          </Typography>
        </Box>

        <Paper
          elevation={24}
          sx={{
            borderRadius: '8px',
            overflow: 'hidden',
            mb: { xs: 1, md: 2 },
            backgroundColor: '#fff',
            boxShadow: '0 10px 20px rgba(0, 0, 0, 0.3)',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: { xs: '40vh', sm: '50vh', md: '60vh' },
            maxHeight: { xs: 'calc(100vh - 200px)', sm: 'calc(100vh - 180px)', md: 'calc(100vh - 160px)' },
          }}
        >
          <Box
            sx={{
              position: 'relative',
              paddingBottom: '56.25%', // 16:9 aspect ratio
              height: 0,
              overflow: 'hidden',
              width: '100%',
              flex: 1,
            }}
          >
            <iframe
              src="https://www.youtube.com/embed/IfpuVCaBOlU"
              title="Pitch Programa Nascer - ThinkWay"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </Box>
        </Paper>

        <Box
          sx={{
            textAlign: 'center',
            mb: { xs: 0.5, md: 1 },
            mt: 'auto',
            flexShrink: 0,
          }}
        >
          <Typography
            variant="h6"
            component="h3"
            sx={{
              color: 'white',
              fontWeight: 'bold',
              mb: 1.5,
              fontSize: { xs: '1rem', md: '1.2rem' },
            }}
          >
            Experimente nossa plataforma
          </Typography>
          
          <PrimaryButton
            onClick={handleDemoClick}
            size="medium"
            sx={{
              px: 3,
              py: 1,
              fontSize: '0.9rem',
              fontWeight: 'bold',
              backgroundColor: '#EF443C',
              minWidth: '200px',
              '&:hover': {
                backgroundColor: '#d73b33',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 12px rgba(239, 68, 60, 0.4)',
              },
              '&:active': {
                transform: 'translateY(0px)',
              },
            }}
          >
            Acessar Demo Interativa
          </PrimaryButton>
        </Box>

        <Box
          sx={{
            textAlign: 'center',
            pt: { xs: 0.5, md: 1 },
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            mt: 'auto',
            flexShrink: 0,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: '0.7rem',
            }}
          >
            © 2025 ThinkWay. Planejamento estratégico descomplicado e na ponta dos dedos.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PitchNascer;